import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MiscModule } from 'projects/core/src/public-api';
import { AccordionModule } from 'primeng/accordion';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { SelectButtonModule } from 'primeng/selectbutton';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CalendarModule } from 'primeng/calendar';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { ToggleCabinetsStatusComponent } from './view/toggle-cabinets-status/toggle-cabinets-status.component';
import { BarcodeScannerModule } from '../barcode-scanner/barcode-scanner.module';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { FinishingPartsComponent } from './view/toggle-cabinets-status/finishing-parts/finishing-parts.component';
import { CabinetListComponent } from './view/toggle-cabinets-status/cabinet-list/cabinet-list.component';
import { CartsModule } from 'projects/cart-tv/src/app/carts.module';
import { HiddenCabinetsDialogComponent } from './view/hidden-cabinets-dialog/hidden-cabinets-dialog.component';
import { PunchListDialogComponent } from './view/punch-list-dialog/punch-list-dialog.component';

@NgModule({
  declarations: [
    HiddenCabinetsDialogComponent,
    PunchListDialogComponent,
    ToggleCabinetsStatusComponent,
    FinishingPartsComponent,
    CabinetListComponent

  ],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    TableModule,
    MatDialogModule,
    MatRippleModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatProgressBarModule,
    InputTextModule,
    SelectButtonModule,
    OverlayPanelModule,
    CalendarModule,
    FileUploadModule,
    MatIconModule,
    MatProgressSpinnerModule,
    AccordionModule,
    MiscModule,
    AutoCompleteModule,
    BarcodeScannerModule,
    ConfirmDialogModule,
    NgxExtendedPdfViewerModule,
    DropdownModule,
    CartsModule
  ],
  exports: [
    ToggleCabinetsStatusComponent
  ],
  entryComponents: [
    ToggleCabinetsStatusComponent,
    PunchListDialogComponent
  ]

})
export class CabinetsMiscModule {
}
